import React, { Fragment, useState, useEffect } from 'react'
import { Sources } from "@components/elements/index"
import { rules } from "@styles/mq"
import theme from "@styles/theme"

import { BannerContent, StyledKenticoImage, BigBannerContainer, BannerResponsiveImagesContainer, BannerTitle, SmallBannerContainer, SmallBannerContent } from "./Banner.styles"
import { Alignments } from "@utils/KontentTypes"

interface BannerProps {
  image: {
    mobile: {
      url: string
      description: string
    },
    tablet: {
      url: string
      description: string
    },
    desktop: {
      url: string
      description: string
    }
  }
  title: string
  textAlign: Alignments
  textVerticalAlign?: 'top' | 'middle' | 'bottom'
  isBiggerBanner?: boolean
  darkTheme?: boolean
};

const Banner: React.FC<BannerProps> = ({ image, title, textAlign, textVerticalAlign = 'middle', isBiggerBanner, darkTheme = false }) => {

  const ResponsiveImages = () => {
    return (
      <BannerResponsiveImagesContainer>
        <div className='block md:hidden'>
          <StyledKenticoImage
            className="banner"
            description={image.mobile.description}
            fallback={`${image.mobile.url}?w=768&auto=format 1x, ${image.mobile.url}?w=1536&auto=format 2x`}
            lowSrc={`${image.mobile.url}?w=100&auto=format`}
            sources={Sources(image.mobile.url, rules, theme.imageBreakpoints)}
          />
        </div>
        <div className='hidden md:block lg:hidden'>
          <StyledKenticoImage
            className="banner"
            description={image.tablet.description}
            fallback={`${image.tablet.url}?w=768&auto=format 1x, ${image.tablet.url}?w=1536&auto=format 2x`}
            lowSrc={`${image.tablet.url}?w=100&auto=format`}
            sources={Sources(image.tablet.url, rules, theme.imageBreakpoints)}
          />
        </div>
        <div className='hidden lg:block'>
          <StyledKenticoImage
            className="banner"
            description={image.desktop.description}
            fallback={`${image.desktop.url}?w=768&auto=format 1x, ${image.desktop.url}?w=1536&auto=format 2x`}
            lowSrc={`${image.desktop.url}?w=100&auto=format`}
            sources={Sources(image.desktop.url, rules, theme.imageBreakpoints)}
          />
        </div>
      </BannerResponsiveImagesContainer>
    );
  }

  return (
    <Fragment>
      {isBiggerBanner === undefined ? (
        <Fragment>
          <SmallBannerContainer>
            <div
              style={{
                width: '100%',
                height: '100%',
                backgroundImage: "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAABQAAAAAAQj4qLAAAAA3NCSVQICAjb4U/gAAAAAElFTkSuQmCC')",
                backgroundRepeat: 'repeat',
              }}
            ></div>
          </SmallBannerContainer>

          {title && (
            <SmallBannerContent textVerticalAlign={textVerticalAlign} textAlign={textAlign}>
              <BannerTitle>{title}</BannerTitle>
            </SmallBannerContent>
          )}
        </Fragment>
      ) : isBiggerBanner === true ? (
        <Fragment>
          <BigBannerContainer>
            <ResponsiveImages />
          </BigBannerContainer>

          {title && (
            <BannerContent textVerticalAlign={textVerticalAlign} textAlign={textAlign} darkTheme={darkTheme}>
              <BannerTitle>{title}</BannerTitle>
            </BannerContent>
          )}
        </Fragment>
      ) : (
        <Fragment>
          <BigBannerContainer>
            <ResponsiveImages />
          </BigBannerContainer>

          {title && (
            <BannerContent textVerticalAlign={textVerticalAlign} textAlign={textAlign} darkTheme={darkTheme}>
              <BannerTitle>{title}</BannerTitle>
            </BannerContent>
          )}
        </Fragment>
      )}
    </Fragment>
  );
};

export default Banner;
